import { render } from "./packtwo.vue?vue&type=template&id=036bceba&scoped=true"
import script from "./packtwo.vue?vue&type=script&lang=js"
export * from "./packtwo.vue?vue&type=script&lang=js"

import "./packtwo.vue?vue&type=style&index=0&id=036bceba&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036bceba"]])

export default __exports__